import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonItem, IonLabel, IonAvatar, IonBadge } from '@ionic/angular/standalone';
import { WorkspaceMember, WorkspaceMemberStatus, WorkspaceRole } from '@crowdctrl/core';
import { formatDate } from '../../utils/date.utils';

@Component({
  selector: 'crowdctrl-workspace-member-item',
  standalone: true,
  imports: [CommonModule, RouterModule, IonItem, IonLabel, IonAvatar, IonBadge],
  templateUrl: './workspace-member-item.component.html',
  styleUrl: './workspace-member-item.component.css',
})
export class WorkspaceMemberItemComponent {
  @Input() member!: WorkspaceMember;
  @Input() isCurrentUser = false;
  @Input() routerLink?: string[] | null;
  @Input() button = false;
  @Input() detail = false;
  @Input() disabled = false;

  formatDate = formatDate;

  getStatusBadgeColor(status?: WorkspaceMemberStatus): string {
    switch (status) {
      case 'Active':
        return 'success';
      case 'Invited':
        return 'warning';
      case 'Disabled':
        return 'danger';
      default:
        return 'medium';
    }
  }

  getStatusDisplay(status?: WorkspaceMemberStatus): string {
    return status || 'Unknown';
  }

  getRoleBadgeColor(role: WorkspaceRole): string {
    // Consistent badge colors per role model spec
    switch (role) {
      case 'Admin':
        return 'primary'; // Admin-level role
      case 'Member':
        return 'secondary'; // Member-level role
      case 'Viewer':
        return 'medium'; // Viewer-level role
      default:
        return 'medium';
    }
  }

  getRoleDisplay(role: WorkspaceRole): string {
    return role;
  }

  getMemberDisplayName(member: WorkspaceMember): string {
    return member.displayName || member.email || 'Unknown Member';
  }
}
